//closing cart drawer on click of arrow button 
document.querySelector('.drawer__inner.gradient.color-scheme-1')?.addEventListener('click', function(e) {
  if (e.target === this) {
    document.querySelector('cart-drawer')?.close();
  }
});

// Update dot pagination on slide change
document.addEventListener('DOMContentLoaded', function() {
  const sliderCounters = document.querySelectorAll('.slider-counter--dots');
  
  sliderCounters.forEach(counter => {
    const dots = counter.querySelectorAll('.slider-counter__link--dots');
    const slider = counter.closest('.product__media-wrapper')?.querySelector('.slider');
    
    if (slider && dots.length > 0) {
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const slideButtons = slider.querySelectorAll('.slider__slide');
          if (slideButtons[index]) {
            slideButtons[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        });
      });
      
      // Update active dot on scroll
      slider.addEventListener('scroll', () => {
        const scrollLeft = slider.scrollLeft;
        const slideWidth = slider.querySelector('.slider__slide')?.offsetWidth || 0;
        const activeIndex = Math.round(scrollLeft / slideWidth);
        
        dots.forEach((dot, index) => {
          dot.classList.toggle('slider-counter__link--active', index === activeIndex);
        });
      });
    }
  });
});

if (!customElements.get('price-range')) {
  customElements.define(
    'price-range',
    class PriceRange extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.price-range-slider');
        this.minInput = this.querySelector('.price-facet__input-min');
        this.maxInput = this.querySelector('.price-facet__input-max');
        this.track = this.querySelector('.range-slider-track');
        this.minHandle = this.querySelector('.range-slider-handle-min');
        this.maxHandle = this.querySelector('.range-slider-handle-max');
        
        if (!this.slider) return;
        
        this.minPrice = parseFloat(this.slider.dataset.min) || 0;
        this.maxPrice = parseFloat(this.slider.dataset.max) || 1000;
        this.currentMin = parseFloat(this.slider.dataset.currentMin) || this.minPrice;
        this.currentMax = parseFloat(this.slider.dataset.currentMax) || this.maxPrice;
        
        this.debounceTimer = null;
        this.debounceDelay = 800;
        
        this.init();
      }

      init() {
        this.updateSliderPosition();
        this.attachEventListeners();
      }

      attachEventListeners() {
        this.minHandle.addEventListener('mousedown', (e) => this.startDrag(e, 'min'));
        this.maxHandle.addEventListener('mousedown', (e) => this.startDrag(e, 'max'));
        
        this.minHandle.addEventListener('touchstart', (e) => this.startDrag(e, 'min'), { passive: false });
        this.maxHandle.addEventListener('touchstart', (e) => this.startDrag(e, 'max'), { passive: false });
        
        this.minInput.addEventListener('input', () => {
          this.updateFromInput();
          this.debouncedFilterUpdate();
        });
        
        this.maxInput.addEventListener('input', () => {
          this.updateFromInput();
          this.debouncedFilterUpdate();
        });
        
        this.minInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.clearDebounce();
            this.triggerFilterUpdate();
          }
        });
        
        this.maxInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.clearDebounce();
            this.triggerFilterUpdate();
          }
        });
      }

      startDrag(e, type) {
        e.preventDefault();
        
        const isTouchEvent = e.type.startsWith('touch');
        
        const handleMove = (e) => {
          const clientX = isTouchEvent ? e.touches[0].clientX : e.clientX;
          const rect = this.slider.getBoundingClientRect();
          const percent = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
          const value = this.minPrice + (this.maxPrice - this.minPrice) * percent;
          
          if (type === 'min') {
            this.currentMin = Math.min(value, this.currentMax - 1);
            this.currentMin = Math.max(this.minPrice, this.currentMin);
          } else {
            this.currentMax = Math.max(value, this.currentMin + 1);
            this.currentMax = Math.min(this.maxPrice, this.currentMax);
          }
          
          this.updateSliderPosition();
          this.updateInputValues();
        };
        
        const handleEnd = () => {
          if (isTouchEvent) {
            document.removeEventListener('touchmove', handleMove);
            document.removeEventListener('touchend', handleEnd);
          } else {
            document.removeEventListener('mousemove', handleMove);
            document.removeEventListener('mouseup', handleEnd);
          }
          
          this.debouncedFilterUpdate();
        };
        
        if (isTouchEvent) {
          document.addEventListener('touchmove', handleMove, { passive: false });
          document.addEventListener('touchend', handleEnd);
        } else {
          document.addEventListener('mousemove', handleMove);
          document.addEventListener('mouseup', handleEnd);
        }
      }

      updateFromInput() {
        const minVal = this.parseInputValue(this.minInput.value);
        const maxVal = this.parseInputValue(this.maxInput.value);
        
        this.currentMin = Math.max(this.minPrice, Math.min(minVal, this.maxPrice));
        this.currentMax = Math.min(this.maxPrice, Math.max(maxVal, this.minPrice));
        
        if (this.currentMin >= this.currentMax) {
          this.currentMin = this.currentMax - 1;
        }
        
        this.updateSliderPosition();
      }

      parseInputValue(value) {
        if (!value) return this.minPrice;
        const cleaned = value.toString().replace(/[^\d.,]/g, '').replace(',', '');
        return parseFloat(cleaned) || 0;
      }

      updateSliderPosition() {
        const minPercent = ((this.currentMin - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;
        const maxPercent = ((this.currentMax - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;
        
        this.minHandle.style.left = minPercent + '%';
        this.maxHandle.style.left = maxPercent + '%';
        this.track.style.left = minPercent + '%';
        this.track.style.width = (maxPercent - minPercent) + '%';
      }

      updateInputValues() {
        this.minInput.value = this.formatPrice(this.currentMin);
        this.maxInput.value = this.formatPrice(this.currentMax);
      }

      formatPrice(value) {
        const rounded = Math.round(value);
        if (this.maxPrice % 1 !== 0) {
          return (Math.round(value * 100) / 100).toFixed(2);
        }
        return rounded.toString();
      }

      debouncedFilterUpdate() {
        this.clearDebounce();
        
        this.debounceTimer = setTimeout(() => {
          this.triggerFilterUpdate();
        }, this.debounceDelay);
      }

      clearDebounce() {
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
          this.debounceTimer = null;
        }
      }

      triggerFilterUpdate() {
        const facetForm = this.closest('facet-filters-form');
        const form = this.closest('form');
        
        if (facetForm && form) {
          const inputEvent = new Event('input', { bubbles: true, cancelable: true });
          form.dispatchEvent(inputEvent);
          
          setTimeout(() => {
            const changeEvent = new Event('change', { bubbles: true, cancelable: true });
            this.minInput.dispatchEvent(changeEvent);
          }, 50);
        } else {
          if (form) {
            const formData = new FormData(form);
            const searchParams = new URLSearchParams(formData);
            const url = `${window.location.pathname}?${searchParams.toString()}`;
            window.location.href = url;
          }
        }
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const facetForms = document.querySelectorAll('facet-filters-form');
  
  facetForms.forEach(form => {
    const formElement = form.querySelector('form');
    if (!formElement) return;
    
    formElement.addEventListener('input', (event) => {
      if (event.target.classList.contains('price-facet__input-min') || 
          event.target.classList.contains('price-facet__input-max')) {
        // Dawn will handle the update
      }
    });
  });
});

class CollectionLoadMore {
  constructor() {
    this.loadMoreBtn = document.querySelector('.load-more-btn');
    this.productGrid = document.querySelector('#product-grid');
    this.productsShown = document.querySelector('.products-shown');
    this.productsTotal = document.querySelector('.products-total');
    
    if (this.loadMoreBtn) {
      this.currentCount = parseInt(this.loadMoreBtn.getAttribute('data-current-count')) || 0;
      this.totalCount = parseInt(this.loadMoreBtn.getAttribute('data-total-count')) || 0;
      this.init();
    }
  }

  init() {
    this.loadMoreBtn.addEventListener('click', this.loadMore.bind(this));
  }

  updateCounter(newProductCount) {
    this.currentCount += newProductCount;
    if (this.productsShown) {
      this.productsShown.textContent = this.currentCount;
    }
  }

  loadMore(e) {
    e.preventDefault();
    
    const btn = this.loadMoreBtn;
    const nextUrl = btn.getAttribute('data-next-url');
    const originalText = btn.textContent;
    
    // Show loading state
    btn.textContent = 'LOADING...';
    btn.disabled = true;
    btn.classList.add('loading');
    
    fetch(nextUrl)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        
        // Get new products
        const newProducts = doc.querySelectorAll('#product-grid > li');
        
        // Append new products
        newProducts.forEach(product => {
          this.productGrid.appendChild(product);
        });
        
        // Update counter
        this.updateCounter(newProducts.length);
        
        // Check if there's another page
        const newLoadMoreBtn = doc.querySelector('.load-more-btn');
        
        if (newLoadMoreBtn) {
          btn.setAttribute('data-next-url', newLoadMoreBtn.getAttribute('data-next-url'));
          btn.textContent = originalText;
          btn.disabled = false;
          btn.classList.remove('loading');
        } else {
          // No more products - hide button but keep counter
          btn.parentElement.style.display = 'none';
        }
        
        // Re-initialize any scripts that need to run on new products
        if (typeof window.Shopify !== 'undefined' && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }
        
        // Trigger animation for new items if enabled
        if (typeof window.SR !== 'undefined') {
          window.SR.reveal('.scroll-trigger');
        }
      })
      .catch(error => {
        console.error('Error loading products:', error);
        btn.textContent = 'ERROR - TRY AGAIN';
        btn.disabled = false;
        btn.classList.remove('loading');
      });
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CollectionLoadMore());
} else {
  new CollectionLoadMore();
}